module.exports = __webpack_public_path__ + "img/yoga.2dbf907c.png";